import React, { type ErrorInfo, type ReactNode } from 'react';
import i18n from 'i18next';
import { reportClientError } from './clientErrorReporter';

interface Props {
  children?: ReactNode;
}

interface State {
  error: Error | null;
  info: ErrorInfo | null;
}

export default class DebugErrorBoundary extends React.Component<Props, State> {
  override state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    this.setState({ info });
    // SU-5 (W7): to the collector, sampled and deduplicated (clientErrorReporter.ts).
    reportClientError(error, 'boundary');
    console.error('[DebugErrorBoundary] Caught error:', error.message);
    console.error('[DebugErrorBoundary] Component stack:', info?.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div style={{ padding: 20, background: '#1a1a2e', color: '#e94560', fontFamily: 'monospace', whiteSpace: 'pre-wrap', maxHeight: '100vh', overflow: 'auto' }}>
          <h2 style={{ color: '#fff' }}>{i18n.t('common:debugError.title')}</h2>
          <p>{String(this.state.error)}</p>
          <h3 style={{ color: '#fff', marginTop: 16 }}>{i18n.t('common:debugError.componentStack')}</h3>
          <p style={{ color: '#ccc', fontSize: 12 }}>{this.state.info?.componentStack}</p>
          <button onClick={() => this.setState({ error: null, info: null })} style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}>{i18n.t('common:debugError.retry')}</button>
        </div>
      );
    }
    return this.props.children;
  }
}
